import { render, staticRenderFns } from "./bidderList.vue?vue&type=template&id=4b5e3f6a&"
import script from "./bidderList.vue?vue&type=script&lang=js&"
export * from "./bidderList.vue?vue&type=script&lang=js&"
import style0 from "./bidderList.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports